var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width: _vm.width, height: _vm.height})},[_c('div',{staticClass:"describeClass"},[_vm._v(_vm._s(_vm.describeText))]),_c('div',{staticClass:"totalClass"},[_vm._v(_vm._s(_vm.totalText)+" "),_c('span',{staticClass:"companyClass"},[_vm._v(_vm._s(_vm.companyName))])]),_c('div',{staticClass:"statisDiv"})])
}
var staticRenderFns = []

export { render, staticRenderFns }